var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.23 18.0018C18.39 17.9118 17.65 18.3216 17.27 18.9913H7.73C7.51 18.6214 7.18 18.3216 6.79 18.1617L6.54 15.9928H19.4C19.63 15.9928 19.84 15.8328 19.89 15.603L21.99 5.60795C22.06 5.29811 21.82 4.99826 21.5 4.99826H5.24L4.94 2.43954C4.91 2.18966 4.7 1.99976 4.44 1.99976H2.5C2.22 1.99976 2 2.21965 2 2.49951V3.49901C2 3.77887 2.22 3.99876 2.5 3.99876H3.11L4.8 18.3916C4.17 18.8813 3.81 19.7409 4.11 20.6404C4.32 21.3001 4.89 21.8098 5.57 21.9498C6.49 22.1397 7.32 21.7099 7.74 21.0003H17.28C17.63 21.6 18.27 21.9998 19.01 21.9998C20.2 21.9998 21.16 20.9403 20.99 19.7109C20.86 18.8313 20.13 18.1117 19.24 18.0117L19.23 18.0018ZM19.75 6.99726L18.2 13.9938H6.3L5.48 6.99726H19.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.0bd839b2365ded4b172d36f90c276a07.svg";
export { ForwardRef as ReactComponent };